module.exports = __webpack_public_path__ + "img/pattern.16fea20a.jpg";